<template>
  <div class="act-video" :style="css" @click.prevent="clickPlay()">
    <div :id="'play'+vid" class="play" style="display: block;" v-show="!playing"></div>
    <video ref="video" x5-video-player-type="h5" x5-video-player-fullscreen="true"
           preload="preload" :poster="poster" webkit-playsinline="" playsinline=""
           :style="videoStyle" :id="'video'+vid"></video>
  </div>
</template>

<script>
  import click_handler from '../../tools/mgtv/click'
  import {updatePlayerURL} from '../../tools/mgtv/video'
  import {removeUnit} from '../../tools/unit'

  export default {
    name: 'ActVideo',
    props: {
      width: {
        type: String,
        default: '6rem'
      },
      vid: {
        type: String,
        default: '432487'
      },
      poster: {
        type: String,
        default: ""
      },
      autoplay: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        playing: false,
        videoInst: null,
        gact: window.gact
      }
    },
    methods: {
      clickPlay(){
        if (this.$refs.video.src) {
          this.play();
        } else {
          updatePlayerURL(vid, 'video' + vid, () => {
            this.play();
          });
        }
      },
      play(){
        const videoInst = this.$refs.video;
        if (gact.is_wx && typeof WeixinJSBridge === "undefined") {
          document.addEventListener("WeixinJSBridgeReady", () => {
            if (videoInst.paused || videoInst.ended) {
              videoInst.play();
            } else {
              videoInst.pause();
            }
          }, false);
        } else {

          if (videoInst.paused || videoInst.ended) {
            videoInst.play();
          } else {
            videoInst.pause();
          }
        }
      }
    },
    computed: {
      videoStyle(){
        return {
          background: "url(" + this.poster + ")  0% 0% / cover no-repeat",
        }
      },
      css(){
        const height = removeUnit(this.width, 'rem') / 6 * 3.5 + 'rem';
        return {
          width: this.width,
          height: height
        }
      }
    },
    mounted(){
      updatePlayerURL(this.vid, 'video' + this.vid, () => {
        if (this.autoplay) {
          this.play();
        }
      });

      this.$refs.video.addEventListener('playing', () => {
        this.playing = true
      }, true);
      this.$refs.video.addEventListener('pause', () => {
        this.playing = false
      }, true);
    }

  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
  @import "../../share/mixins.styl"
  .act-video
    position relative
    > video
      width 100%
      height 100%
      center()
      object-fit: fill

  .poster
    width 100%
    center()
    z-index 1

  .play
    center()
    background-image: url(../../../static_niunai/img/player.png);
    background-size: contain;
    width 0.7rem
    height 0.7rem
    z-index 2
    cursor pointer
</style>



// WEBPACK FOOTER //
// src/components/common/ActVideo.vue